module.exports = {
	"version": "1.0.1x0056"
};


//////////////////
// WEBPACK FOOTER
// ./version.json
// module id = 1054
// module chunks = 0